var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_980_9389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03184 4.1582C8.03184 4.10664 7.98965 4.06445 7.93809 4.06445L7.16465 4.06797L5.9998 5.45664L4.83613 4.06914L4.06152 4.06563C4.00996 4.06563 3.96777 4.10664 3.96777 4.15938C3.96777 4.18164 3.97598 4.20273 3.99004 4.22031L5.51465 6.03672L3.99004 7.85195C3.97588 7.86913 3.96802 7.89063 3.96777 7.91289C3.96777 7.96445 4.00996 8.00664 4.06152 8.00664L4.83613 8.00313L5.9998 6.61445L7.16348 8.00195L7.93691 8.00547C7.98848 8.00547 8.03066 7.96445 8.03066 7.91172C8.03066 7.88945 8.02246 7.86836 8.0084 7.85078L6.48613 6.03555L8.01074 4.21914C8.0248 4.20273 8.03184 4.18047 8.03184 4.1582Z",
    fill: "#1B0845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0.761719C3.10078 0.761719 0.75 3.1125 0.75 6.01172C0.75 8.91094 3.10078 11.2617 6 11.2617C8.89922 11.2617 11.25 8.91094 11.25 6.01172C11.25 3.1125 8.89922 0.761719 6 0.761719ZM6 10.3711C3.59297 10.3711 1.64062 8.41875 1.64062 6.01172C1.64062 3.60469 3.59297 1.65234 6 1.65234C8.40703 1.65234 10.3594 3.60469 10.3594 6.01172C10.3594 8.41875 8.40703 10.3711 6 10.3711Z",
    fill: "#1B0845"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_980_9389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.fdcd430be665ad63f56c78021ae5706d.svg";
export { ForwardRef as ReactComponent };